// import { NewPermissionRequest } from 'src/messages/operation-request'

// export const isKusamaMessage = (request: NewPermissionRequest<string>) => {}
